import { useState, useEffect, useCallback } from 'react';

export default function useHash() {
  const [hash, setHash] = useState(() => location.hash);
  const handleHashChange = useCallback(() => {
    setHash(location.hash);
  }, []);
  useEffect(() => {
    window.addEventListener('hashchange', handleHashChange, false);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [handleHashChange]);

  return hash;
}

export function useHash2() {
  const [hash, setHash] = useState(() => location.hash);
  const handleHashChange = useCallback(() => {
    setHash(location.hash);
  }, []);
  useEffect(() => {
    window.addEventListener('hashchange', handleHashChange, false);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [handleHashChange]);

  return [hash, setHash];
}